export default __webpack_public_path__ + "d51a99cc94312e8e9de793a5d67aa20e.png";